/* ***************************************************************************************************************************************** */
/* THIS JS FILE DEPENDS ON GLOBAL VARIABLES DEFINED IN 'Views\Shared\_GlobalHeaderLeft.cshtml' AND IT SHOULD BE INCLUDED ONLY FROM THAT FILE */
/* ***************************************************************************************************************************************** */

function GlobalHeaderLeft_RestorePatientSelectionSession_Callback(result, param1) {
    if (result.result == "OK")
        GlobalHeaderLeft_AjaxPost(param1.postData, param1.controllerName, param1.actionName, param1.callbackSuccess, param1.failMessage, param1.divLoading, 
            param1.optionalParam1, param1.optionalParam2, param1.optionalParam3);
    else if (param1.failMessage != undefined && param1.failMessage != "")
        ReportGridAjax_ErrorHandler(param1.failMessage, result);
}

function GlobalHeaderLeft_AjaxPost(postData, controllerName, actionName, callbackSuccess, failMessage, divLoading, 
    optionalParam1, optionalParam2, optionalParam3) {
    if (postData == null || postData == undefined) // postData should always be populated if the AJAX call is made intentionally, if no data required to be passed, call with {}
        return;
    Kendo_ShowOrHideLoadingImage(divLoading, true);
    var ajaxUrl = globalHeaderLeft_Template_AjaxUrl;
    ajaxUrl = ajaxUrl.replace("___ACT___", actionName).replace("___CONT___", controllerName);
    var request = $.ajax({
        url: ajaxUrl,
        method: "POST",
        data: postData,
        success: function (data) {
            Kendo_ShowOrHideLoadingImage(divLoading, false);
            if (AjaxResult_CommonResultHandled(data))
                return;
            if (data != undefined && data.result != undefined && data.result == "PAT_SESSION_MISSING") {
                if (globalHeaderLeft_CurrentPatient != undefined && globalHeaderLeft_CurrentPatient != null && 
                    globalHeaderLeft_SelectedPatientsJSon != undefined && globalHeaderLeft_SelectedPatientsJSon != null && globalHeaderLeft_SelectedPatientsJSon.length > 0) {
                    var passParams = {
                        postData: postData, controllerName: controllerName, actionName: actionName, callbackSuccess: callbackSuccess, failMessage: failMessage, 
                        divLoading: divLoading, optionalParam1: optionalParam1, optionalParam2: optionalParam2, optionalParam3: optionalParam3
                    };
                    var sessionRestoreData = { currentPatient: globalHeaderLeft_CurrentPatient, selectedPatientsJSon: globalHeaderLeft_SelectedPatientsJSon };
                    GlobalHeaderLeft_AjaxPost(sessionRestoreData, "PatientListView", "RestorePatientSelectionSession", 
                        GlobalHeaderLeft_RestorePatientSelectionSession_Callback, failMessage, divLoading, passParams);
                }
                else if (failMessage != undefined && failMessage != "")
                    ReportGridAjax_ErrorHandler(failMessage, result);
                return;
            }
            if (callbackSuccess)
                callbackSuccess(data, optionalParam1, optionalParam2, optionalParam3);
        },
        error: function (result) {
            Kendo_ShowOrHideLoadingImage(divLoading, false);
            if (failMessage != undefined && failMessage != "")
                ReportGridAjax_ErrorHandler(failMessage, result);
            GlobalHeaderLeft_DisableNavButtons(false);
        }
    });
}

function GlobalHeaderLeft_ClearSelectedSite(url) {
    GlobalHeaderLeft_AjaxPost({}, "Navigation", "RemoveSelectedSite", GlobalHeaderLeft_ClearSelectedSite_Callback, globalHeaderLeft_Error_FailedClearSite, "divMasterAppBodyContent", url);
}

function GlobalHeaderLeft_ClearSelectedSite_Callback(data, url) {
    if (data && data.result == "OK") {
        $("#trSelectedSite").hide();
        $("#NavBarPatientNavigation").hide(); // ????? should we remove selected patients, they could be from different sites anyway, selected in main menu "Patients"
    }
    if (url != null && url != undefined) {
        NavigateAway_Callback(url);
    }
}


function GlobalHeaderLeft_Navigate(direction) {
    //direction:
    //== 0 - current
    // > 0 - next
    // < 0 - previous
    if (MainMenuLeftSideBar && MainMenuLeftSideBar.CollapseSideBar != undefined)
        MainMenuLeftSideBar.CollapseSideBar();
    if (NavigateAwayWithCallBack(globalHeaderLeft_Template_AjaxUrl, "Navigation", 'GlobalHeaderLeft_Navigate', direction))
        return;
    var isPanelVisible = ($("#divPanelSelection").length > 0 && $("#divPanelSelection").is(":visible"));
    var isPanelCollapsed = false;
    if (isPanelVisible)
        isPanelCollapsed = !PanelSelection_IsPanelExpanded();

    GlobalHeaderLeft_DisableNavButtons(true);
    GlobalHeaderLeft_AjaxPost({ direction: direction }, "PatientListView", "NavigatePatientsAjax", GlobalHeaderLeft_Navigate_Callback, globalHeaderLeft_Error_FailedNavigatePatients, "divMasterAppBodyContent", direction, isPanelCollapsed);
}

function GlobalHeaderLeft_Navigate_Callback(data, direction, isPanelCollapsed) {
    if (data) {
        if (data.result == "OK") {
            var isPanelVisible = ($("#divPanelSelection").length > 0 && $("#divPanelSelection").is(":visible"));
            if (!isPanelVisible) {
                //in this case always show current b/c navigation already happened
                window.location.href = globalHeaderLeft_HrefSelectCurrentPatientList;
            }
            else {
                GlobalHeaderLeft_PrepDataForNavigationRestore();                      
                GlobalHeaderLeft_RefreshPatient(data.id, data.tfid, data.tot, data.caption, false, isPanelCollapsed, true);
            }
        }
        else {
            //navigation not possible
            ReportGridAjax_ErrorHandler(globalHeaderLeft_Error_PatientNavigationNotPossible, null);
            GlobalHeaderLeft_DisableNavButtons(false);
        }
    }
}

function GlobalHeaderLeft_PrepDataForNavigationRestore() {
    //prepare data structure with required info to restore the next patient:
    var allVisitsGridDisplayed = ($("#divBodyRender").length > 0 && $("#divBodyRender").find("#divGlobalNavigation_AllVisitsGrid").length > 0);
    var allFormsGridDisplayed = ($("#divBodyRender").length > 0 && $("#divBodyRender").find("#divGlobalNavigation_AllFormsGrid").length > 0);

    if (panelSelection_RestoreNextPatient == null) {
        panelSelection_RestoreNextPatient = { 
            FormsTabActive: $("#FormsTabId").hasClass("active-tab"),
            AllVisitsGridDisplayed: allVisitsGridDisplayed, 
            AllFormsGridDisplayed: allFormsGridDisplayed,
            RenderedFormId:  (panelSelection_CurrentExpandedInfo_RenderedForm != null && panelSelection_CurrentExpandedInfo_RenderedForm != undefined) ? panelSelection_CurrentExpandedInfo_RenderedForm.Id : 0,//used for restoring (currently rendered form) and used for returning data (new rendered form)
            RenderedProFormId: (panelSelection_CurrentExpandedInfo_RenderedForm != null && panelSelection_CurrentExpandedInfo_RenderedForm != undefined) ? panelSelection_CurrentExpandedInfo_RenderedForm.ProFormId : 0,
            RenderedFormInstanceNo: (panelSelection_CurrentExpandedInfo_RenderedForm != null && panelSelection_CurrentExpandedInfo_RenderedForm != undefined) ? panelSelection_CurrentExpandedInfo_RenderedForm.FormInstanceNo : 0,
            ExpandedVisitId: 0,//not used for restoring - used for returning data only
            ExpandedVisitProId: (panelSelection_CurrentExpandedInfo_Visits != null && panelSelection_CurrentExpandedInfo_Visits != undefined) ? panelSelection_CurrentExpandedInfo_Visits.proId : 0, 
            ExpandedVisitInstanceNo: (panelSelection_CurrentExpandedInfo_Visits != null && panelSelection_CurrentExpandedInfo_Visits != undefined) ? panelSelection_CurrentExpandedInfo_Visits.instanceNo : 0, 
            ExpandedFormsProId: (panelSelection_CurrentExpandedInfo_Forms != null && panelSelection_CurrentExpandedInfo_Forms != undefined) ? panelSelection_CurrentExpandedInfo_Forms.proFormId : 0,
            RefreshGridPatId: 0,//not used for restoring - used for returning data only
            RefreshGridSysFormId: 0,//not used for restoring - used for returning data only
            RefreshGridCaption: ""//not used for restoring - used for returning data only
        };
    }
    else {
        //the following can be set on every navigation action
        panelSelection_RestoreNextPatient.FormsTabActive = $("#FormsTabId").hasClass("active-tab");

        //if we have reset form info for navigation, set the current values
        if (panelSelection_RestoreNextPatient.RenderedProFormId == 0 && panelSelection_CurrentExpandedInfo_RenderedForm != null && panelSelection_CurrentExpandedInfo_RenderedForm != undefined) {
            panelSelection_RestoreNextPatient.RenderedFormId = panelSelection_CurrentExpandedInfo_RenderedForm.Id;//used for restoring (currently rendered form) and used for returning data (new rendered form)
            panelSelection_RestoreNextPatient.RenderedProFormId = panelSelection_CurrentExpandedInfo_RenderedForm.ProFormId;
            panelSelection_RestoreNextPatient.RenderedFormInstanceNo = panelSelection_CurrentExpandedInfo_RenderedForm.FormInstanceNo;
        }
        if (panelSelection_RestoreNextPatient.AllFormsGridDisplayed == null) {
            panelSelection_RestoreNextPatient.AllFormsGridDisplayed = allFormsGridDisplayed;
        }
        if (panelSelection_RestoreNextPatient.AllVisitsGridDisplayed == null) {
            panelSelection_RestoreNextPatient.AllVisitsGridDisplayed = allVisitsGridDisplayed;
        }
    }

    //remove main content - it is wrong for the current patient - we will load the grid for current patient if grid is currently displayed
    RenderHtmlIntoControl("", "divBodyRender");

    panelSelection_CurrentExpandedInfo_RenderedForm = null;//we don't know what will be rendered in divBodyRender - if form, we'll set the ID on callback
    panelSelection_CurrentExpandedInfo_Visits = null;//we have to reset it because we may not find the matching pro selection - if we do, then  we'll restore it
    panelSelection_CurrentExpandedInfo_Forms = null;//we have to reset it because we may not find the matching pro selection - if we do, then  we'll restore it
}

function GlobalHeaderLeft_OpenPatientSelection() {
    if (NavigateAwayWithCallBack(globalHeaderLeft_Template_AjaxUrl, "Navigation", "GlobalHeaderLeft_OpenPatientSelection"))
        return;
    GlobalHeaderLeft_AjaxPost({}, "PatientSelection", "", GlobalHeaderLeft_OpenPatientSelection_Callback, globalHeaderLeft_Error_FailedOpenPatSelection, "divMasterAppBodyContent");
}

function GlobalHeaderLeft_OpenPatientSelection_Callback(data) {
    var wndWidth = 200;
    var lnkOffset = $("#PatientsCountLinkElement").offset();
    var lnkWidth = $("#PatientsCountLinkElement").width();
    var lnkHeight = $("#PatientsCountLinkElement").height();

    var offX = (wndWidth - lnkWidth) / 2;
    var posX = lnkOffset.left - offX;
    if (posX < 0)
        posX = 0;

    var nonCenteredWindowProperties = { top: lnkOffset.top + lnkHeight, left: posX, width: wndWidth };

    ShowModal(data, true, true, nonCenteredWindowProperties, true);
}

function GlobalHeaderLeft_RefreshPatient_Click(id, tfid, tot, caption, fromCache, isPanelCollapsed, isPatientNavigation) {
    if (NavigateAwayWithCallBack(globalHeaderLeft_Template_AjaxUrl, "Navigation", "GlobalHeaderLeft_RefreshPatient_Click", id, tfid, tot, caption, fromCache, isPanelCollapsed, isPatientNavigation))
        return;
    GlobalHeaderLeft_RefreshPatient(id, tfid, tot, caption, fromCache, isPanelCollapsed, isPatientNavigation);
}


function GlobalHeaderLeft_RefreshPatient(id, tfid, tot, caption, fromCache, isPanelCollapsed, isPatientNavigation) {
    if (typeof(panelSelection_CurrentExpandedInfo_Visits) == "undefined" || typeof(panelSelection_CurrentExpandedInfo_Forms) == "undefined")
        return;//there is nothing to refresh - might happen when system forms are rendered outside of navigation

    globalHeaderLeft_CurrentPatient = id;
    if (fromCache == null || fromCache == undefined || typeof (fromCache) != "boolean")
        fromCache = false;
    if (isPatientNavigation == null || isPatientNavigation == undefined || typeof (isPatientNavigation) != "boolean")
        isPatientNavigation = false;
    var isPanelVisible = ($("#divPanelSelection").length > 0 && $("#divPanelSelection").is(":visible"));
    if (isPanelVisible) {
        if ((isPanelCollapsed == null || isPanelCollapsed == undefined) && typeof (PanelSelection_IsPanelExpanded) == "function")
            isPanelCollapsed = !PanelSelection_IsPanelExpanded();
        else if (typeof (isPanelCollapsed) != "boolean")
            isPanelCollapsed = false;
    }
    else
        isPanelCollapsed = false;

    //this is for setting initial visibility after refresh
    var isFormsTabActive = ($("#FormsTabId").hasClass("active-tab"));
    var isVisitsTabContentVisitsVisible = !isFormsTabActive && (panelSelection_CurrentExpandedInfo_Visits == null);
    var isFormsTabContentProFormsVisible = isFormsTabActive && (panelSelection_CurrentExpandedInfo_Forms == null);
    var isVisitsTabContentFormsVisible = !isFormsTabActive && (panelSelection_CurrentExpandedInfo_Visits != null);
    var isFormsTabContentProFormsFormsVisitVisible = isFormsTabActive && (panelSelection_CurrentExpandedInfo_Forms != null);
    var rerenderForm = (!fromCache && !isPatientNavigation);

    var expandedVisitId = 0;
    var expandedProFormId = 0;
    if (panelSelection_CurrentExpandedInfo_Visits != null || panelSelection_CurrentExpandedInfo_Forms != null) {
        if (panelSelection_CurrentExpandedInfo_Visits != null)
            expandedVisitId = panelSelection_CurrentExpandedInfo_Visits.visitId;
        if (panelSelection_CurrentExpandedInfo_Forms != null)
            expandedProFormId = panelSelection_CurrentExpandedInfo_Forms.proFormId;
    }

    var ajaxData = {
        id: id, tfid: tfid, tot: tot, caption: caption, isPanelVisible: isPanelVisible, fromCache: fromCache,
        isFormsTabActive: isFormsTabActive,
        isVisitsTabContentVisitsVisible: isVisitsTabContentVisitsVisible, isFormsTabContentProFormsVisible: isFormsTabContentProFormsVisible,
        isVisitsTabContentFormsVisible: isVisitsTabContentFormsVisible, isFormsTabContentProFormsFormsVisitVisible: isFormsTabContentProFormsFormsVisitVisible,
        expandedVisitId: expandedVisitId, expandedProFormId: expandedProFormId, 
        restoreNavigationForNextPatient: (isPatientNavigation && panelSelection_RestoreNextPatient && panelSelection_RestoreNextPatient != null) ? JSON.stringify(panelSelection_RestoreNextPatient) : null
    };
    GlobalHeaderLeft_AjaxPost(ajaxData,
        "Navigation", "RefreshPatient", GlobalHeaderLeft_RefreshPatient_Callback, globalHeaderLeft_Error_FailedRefreshPatient, isPanelVisible ? "divPanelSelection" : "divMasterAppBodyContent", 
        isPanelVisible, isPanelCollapsed, rerenderForm);
}

function GlobalHeaderLeft_RefreshPatient_Callback(data, isPanelVisible, isPanelCollapsed, rerenderForm) {
    //refresh site/patients - do not proceed until this is done!
    //if (data && data.result != undefined) {
    //    if (data.result == "NOPAT") {
    //        if (globalHeaderLeft_Error_FailedRefreshPatient != undefined && globalHeaderLeft_Error_FailedRefreshPatient != "")
    //            ReportGridAjax_ErrorHandler(globalHeaderLeft_Error_FailedRefreshPatient, data);
    //        if (globalHeaderLeft_HrefHome)
    //            NavigateAway(globalHeaderLeft_HrefHome, null, true);
    //        return;
    //    }
    //}

    GlobalHeaderLeft_AjaxPost({},
        "Home", "RefreshTrialSitePatientsHeader", GlobalHeaderLeft_RefreshPatient_Callback_RefreshTrialSitePatientsHeader_Callback, globalHeaderLeft_Error_FailedRefreshPatient, "GlobalHeaderLeft_TrialSitePatients", "GlobalHeaderLeft_TrialSitePatients",
            {data: data, isPanelVisible: isPanelVisible, isPanelCollapsed: isPanelCollapsed, rerenderForm: rerenderForm});
}

function GlobalHeaderLeft_DisableNavButtons(disableButtons) {
    if ($("#NavBarPatNavigationNext").length > 0)
        $("#NavBarPatNavigationNext").css("pointer-events", disableButtons ? "none" : "auto");
    if ($("#NavBarPatNavigationPrev").length > 0)
        $("#NavBarPatNavigationPrev").css("pointer-events", disableButtons ? "none" : "auto");
}

function GlobalHeaderLeft_RefreshPatient_Callback_RefreshTrialSitePatientsHeader_Callback(dataX, panelX, oldCallbackParams) {
    RenderHtmlIntoControl(dataX, panelX);//this is RefreshTrialSitePatientsHeader
    GlobalHeaderLeft_DisableNavButtons(true);

    //now we continue with RefreshPatient
    var data = oldCallbackParams.data;
    var isPanelVisible = oldCallbackParams.isPanelVisible;
    var isPanelCollapsed = oldCallbackParams.isPanelCollapsed;
    var rerenderForm = oldCallbackParams.rerenderForm;    

    //refresh the grid for current patient?
    if ($("#divGlobalNavigation_AllVisitsGrid").length > 0 || $("#divGlobalNavigation_AllFormsGrid").length > 0) {
        var anch = $("#divBodyRender").find("a[onclick^='ReportingGrid_ResetCacheAndReloadGrid']");
        if (anch.length == 1)
            anch.trigger('click');
    }

    if (isPanelVisible) {
        if (isPanelCollapsed)
            PanelSelection_MainMenuContent_SetVisibility(false);
        panelSelection_CurrentExpandedInfo_ScrollY_Pat = $('#tabMenuItemsFormsList_PF').scrollTop();
        panelSelection_CurrentExpandedInfo_ScrollY_Vis = $('#tabMenuItemsFormsList_VS').scrollTop();

        RenderHtmlIntoControl(data.panelSelectionActions, "divPanelActions", false);
        RenderHtmlIntoControl(data.panelSelectionContent, "divMainMenuContent", false);

        var restorePatNav;
        if (data.restoreNextPat && (typeof data.restoreNextPat === 'string' || data.restoreNextPat instanceof String))
            restorePatNav = JSON.parse(data.restoreNextPat);
        if (restorePatNav) {
            //if that was navigation to next patient, we may have to restore the selected info's because we set them to null, but only if there was something there
            if (restorePatNav.ExpandedVisitProId > 0)
                panelSelection_CurrentExpandedInfo_Visits = {
                    proId: restorePatNav.ExpandedVisitProId,
                    instanceNo: restorePatNav.ExpandedVisitInstanceNo, 
                    visitId: restorePatNav.ExpandedVisitId
                };
            if (restorePatNav.ExpandedFormsProId > 0)
            panelSelection_CurrentExpandedInfo_Forms = {
                proFormId: restorePatNav.ExpandedFormsProId
            };
            if (restorePatNav.RenderedFormId > 0 && restorePatNav.RenderedProFormId > 0 && restorePatNav.RenderedFormInstanceNo > 0) {
                //render form
                PanelSelection_HighlightForm({ Id: restorePatNav.RenderedFormId, ProFormId: restorePatNav.RenderedProFormId, FormInstanceNo: restorePatNav.RenderedFormInstanceNo });//we want to highligt on click
                PanelSelection_RenderForm(
                    { Id: restorePatNav.RenderedFormId, ProFormId: restorePatNav.RenderedProFormId, FormInstanceNo: restorePatNav.RenderedFormInstanceNo }, 
                    "ICrf", "Form", "", "");
                rerenderForm = false;
            }
            else if (restorePatNav.AllVisitsGridDisplayed && restorePatNav.RefreshGridPatId > 0) {
                PanelSelection_OnAllVisitsClick(null,'Grid','VisitListView', restorePatNav.RefreshGridPatId, restorePatNav.RefreshGridSysFormId, 6, restorePatNav.RefreshGridCaption);
                rerenderForm = false;
            }
            else if (restorePatNav.AllFormsGridDisplayed && restorePatNav.ExpandedVisitId > 0 && restorePatNav.RefreshGridPatId > 0) {
                PanelSelection_OnAllFormsClick(null,'Grid','FormListView', restorePatNav.ExpandedVisitId, restorePatNav.RefreshGridPatId, 8, restorePatNav.RefreshGridCaption);
                rerenderForm = false;
            }
            else
                GlobalHeaderLeft_DisableNavButtons(false);
        }
        else
            GlobalHeaderLeft_DisableNavButtons(false);

        if ($("#FormsTabId").hasClass("active-tab")) {
            $("#VisitsTabId").removeClass("active-tab");
            $("#VisitsTabContentId").removeClass("active-tab");
            $("#FormsTabContentId").addClass("active-tab");
        }

        PatientSelection_RestoreScrollAndSelection(isPanelCollapsed);//this will refresh buttons and resize
    }
    else
        GlobalHeaderLeft_DisableNavButtons(false);

    if (rerenderForm) {
        var rerenderFormInfo = { RenderedFormId:  (panelSelection_CurrentExpandedInfo_RenderedForm != null && panelSelection_CurrentExpandedInfo_RenderedForm != undefined) ? panelSelection_CurrentExpandedInfo_RenderedForm.Id : 0,
            RenderedProFormId: (panelSelection_CurrentExpandedInfo_RenderedForm != null && panelSelection_CurrentExpandedInfo_RenderedForm != undefined) ? panelSelection_CurrentExpandedInfo_RenderedForm.ProFormId : 0,
            RenderedFormInstanceNo: (panelSelection_CurrentExpandedInfo_RenderedForm != null && panelSelection_CurrentExpandedInfo_RenderedForm != undefined) ? panelSelection_CurrentExpandedInfo_RenderedForm.FormInstanceNo : 0 };

        if (rerenderFormInfo.RenderedFormId > 0 && rerenderFormInfo.RenderedProFormId > 0 && rerenderFormInfo.RenderedFormInstanceNo > 0)
            PanelSelection_RenderForm(
                { Id: rerenderFormInfo.RenderedFormId, ProFormId: rerenderFormInfo.RenderedProFormId, FormInstanceNo: rerenderFormInfo.RenderedFormInstanceNo }, 
                    "ICrf", "Form", "", "");        
    }
}

function PatientSelection_RestoreScrollAndSelection(isPanelCollapsed) {
    if (isPanelCollapsed) {
        PanelSelection_CollapseExpandNavPanel(true);
        PanelSelection_MainMenuContent_SetVisibility(true);
    }
    else
        PanelSelection_ShowOrHideActionButtons();//we'll always call resize from this function          

    setTimeout(PatientSelection_RestoreScrollPositions, 500);//in 500ms try to restore scrollbars (we cannot do that now because view might not be rendered yet)

    if (panelSelection_CurrentExpandedInfo_RenderedForm != null)
        PanelSelection_HighlightForm(panelSelection_CurrentExpandedInfo_RenderedForm);
}

function PatientSelection_RestoreScrollPositions() {
    if (panelSelection_CurrentExpandedInfo_ScrollY_Vis != null)
        $('#tabMenuItemsFormsList_VS').scrollTop(panelSelection_CurrentExpandedInfo_ScrollY_Vis);

    if (panelSelection_CurrentExpandedInfo_ScrollY_Pat != null)
        $('#tabMenuItemsFormsList_PF').scrollTop(panelSelection_CurrentExpandedInfo_ScrollY_Pat);
}

function PatientSelection_SelectPatient(patientListItemCount) {
    GlobalHeaderLeft_AjaxPost({ patientListItemCount: patientListItemCount }, "PatientListView", "SelectPatientFromSession", PatientSelection_SelectPatient_Callback, globalHeaderLeft_Error_FailedSelectPatient, "divPopupPatientSelection");
}

function PatientSelection_SelectPatient_Callback(data, direction) {
    if (data && data.result == "OK") {
        CloseModelPopup();
        var isPanelVisible = ($("#divPanelSelection").length > 0 && $("#divPanelSelection").is(":visible"));
        if (!isPanelVisible) {
            window.location.href = globalHeaderLeft_HrefSelectCurrentPatientList;
        }
        else {
            GlobalHeaderLeft_PrepDataForNavigationRestore();
            GlobalHeaderLeft_RefreshPatient(data.id, data.tfid, data.tot, data.caption, false, null, true);
        }
    }
    else {
        //navigation not possible
        ReportGridAjax_ErrorHandler(globalHeaderLeft_Error_PatientSelectionNotPossible, null);
    }
}
